import { VestingHistory } from '@apeiron/reward'
import { AnyObject, ChainNetworkType, MayNull } from '@apeiron/temp'
import * as R from 'ramda'
import { useCallback } from 'react'

const useMakeVestingHistory = (): Hook => {
  const makeVestingHistory = useCallback((node: AnyObject): VestingHistory => {
    return {
      amount: R.propOr('0', 'amount', node),
      currency: R.propOr('', 'currencyCode', node),
      claimedAt: R.propOr('', 'claimedAt', node),
      network: R.propOr(ChainNetworkType.Ronin, 'network', node),
      transactionHash: R.propOr('', 'transactionHash', node)
    }
  }, [])

  const makeVestingHistories = useCallback(
    (result: MayNull<AnyObject>): VestingHistory[] => {
      const edges = R.propOr([], 'edges', result) as AnyObject[]

      return R.map((edge: AnyObject) => {
        const node = R.propOr({}, 'node', edge) as AnyObject

        return makeVestingHistory(node)
      }, edges)
    },
    [makeVestingHistory]
  )

  return {
    makeVestingHistory,
    makeVestingHistories
  }
}

type Hook = {
  makeVestingHistory: (node: AnyObject) => VestingHistory
  makeVestingHistories: (result: MayNull<AnyObject>) => VestingHistory[]
}

export default useMakeVestingHistory
